import React, { Component } from 'react';
import $ from 'jquery';
import AdminLayout from './../layout';
import { MOBILE_REGEX, URL_REGEX } from '../../../constant.js';
import { partnerCategory, partnerApi, partnerAddBranch, fetch_category_by_ids } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import SimpleReactValidator from 'simple-react-validator';
import Autosuggest from 'react-autosuggest';
import Geocode from "react-geocode";
import ReactTooltip from "react-tooltip";
import PlacesAutocomplete from 'react-places-autocomplete';
Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

class partnerBranchAdd extends Component {

  constructor(props) {
    super(props);
    let qrystr = window.location.search;
    const urlParams = new URLSearchParams(qrystr);
    let sid = urlParams.get('sid');
    let login_id = urlParams.get('login_id');

    this.state = {
      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
      is_completed: localStorage.getItem('is_completed') ? (localStorage.getItem('is_completed')) : 0,
      access: [],
      sid: sid != null ? sid : -1,
      main_id: 0,
      suggestions: [],
      user_type: 0,
      spartner_id: 0,
      btnDisabled:false,
      registration_no: '',
      org_name: '',
      first_name: '',
      last_name: '',
      address: '',
      google_address: '',
      location: '',
      state: '',
      pincode: '',
      email: '',
      contact_number: '',
      landline: '',
      social_media: '',
      social_media_link: '',
      sub_category: [],
      type_one: [],
      type_two: [],
      first_category: [],
      second_category: [],
      third_category: [],
      location_list: [],
      spartner_list: [],
      suggestions: [],
      first_type_mul: true,
      second_mult: false,
      third_mult: false,
      lbl_sec_cate: '',
      lbl_third_cate: '',
      latitude: '',
      longitude: '',
      is_completd: 0,
      main_access: '',
      main_category: 0,
      button: 'Submit',
      master_data: [],
      uids: [],
      cids: [],
      cat_list:[],
      selected_cids:[],
      social_link_data: [{ id: "li", name: 'LinkedIn', link: "" },
      { id: "fb", name: 'Facebook', link: "" }, { id: "in", name: 'Instagram', link: "" }],
      autosaveddata: [],
      parent_address:'madras'
    }

    this.validator = new SimpleReactValidator({
        validators: {
          checkMobile: MOBILE_REGEX,
          checkUrl: URL_REGEX,
          not_eq_ho:{
            message:"Address must not be the same as in Head Office",
            rule:(val,params,validator)=>{
                return (val==params[0]);
            }
          }
          /* test dev
          notsame: {  // name the rule
            message: 'The :attribute must not be same as in Head Office',
            rule: (val, params, validator) => {
              return validator.helpers.testRegex(val,/^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/i) && params.indexOf(val) === -1
            }
          }*/
        }
      });
      this.getProfileData = this.getProfileData.bind(this);
      this.getCategories = this.getCategories.bind(this);
      this.handleCustomSelect = this.handleCustomSelect.bind(this);
  }

 
  handleCustomSelect = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    let page_data = this.state.selected_cids;
    page_data[propName] = value;
    this.setState({ page_data });
  };

  handleplaceChangeIns = google_address => {
    this.setState({ google_address });
  };

  handleplaceSelectIns = address => {
    this.setState({ google_address: address });
  };


  getCategories = (cids) => {

    let req = JSON.stringify({
      cids: cids
    });

    fetch_category_by_ids(req).then(res => {

      if (res.status === 1) {
        let cat_list = res.category_data;
        this.setState({
          cat_list: cat_list.result
        })

      }
     

    });

  }

  getProfileData = () => {
    const { user_type, login_id, is_completd, current_category, set_id } = this.state.user_data;

    let req = JSON.stringify({
      user_type: user_type,
      login_id: login_id,
      is_completd: is_completd,
      category: current_category,
      sid: this.state.sid != -1 ? this.state.sid : set_id,
      url: 'getProfileData'
    });
    partnerApi(req).then(res => {
      if (res.status === 1) {
        let data = res.result;
        this.Geocode_location(data.address);

        let social_link_dataw_x_twitter = (data.social_link_data) ? JSON.parse(data.social_link_data).filter(sociallink => sociallink.name !== "Twitter"):this.state.social_link_data;

        if (user_type === 1) {


          this.setState({
            vendor_id : data.vendor_id,
            registration_no: data.organisation_register_number,
            org_name: data.organisation_name,
            temp_org_name: data.organisation_name,
            first_name: '',
            last_name: '',
            address: '',
            temp_org_address: '',
            google_address: '',
            city: data.location,
            state: data.state,
            pincode: data.pin_code,
            email: data.institution_email_address,
            //social_link_data: social_link_dataw_x_twitter ? JSON.parse(social_link_dataw_x_twitter) : this.state.social_link_data,
            social_link_data: social_link_dataw_x_twitter,
            contact_number: data.phone_number,
            landline: data.landline_number,
            social_media: data.social_link,
            social_media_link: data.social_media_link,
            main_access: data.main_access,
            is_completd: data.is_completd,
          });
        } else if (user_type === 2) {
          this.setState({
            vendor_id:data.vendor_id,
            main_id: data.main_id ? data.main_id : 0,
            registration_no: '',
            org_name: '',
            first_name: data.first_name,
            last_name: data.last_name,
            address: '',
            google_address: '',
            city: data.location,
            state: data.state,
            pincode: data.pin_code,
            email: data.email_id,
            contact_number: data.phone_number,
            landline: data.landline_number,
            social_media: data.social_link,
            social_media_link: data.social_media_link,
            main_access: data.main_access,
            is_completd: data.is_completd,
          });
        }
        this.setState({
          location_list: res.location,
          master_data: data.master_data,
          uids: data.uids,
          cids: data.cids
        })

        this.getCategories(data.cids);
      }

    });
  }

  componentDidMount() {

    this.getProfileData();
    

  }

  componentDidUpdate() {
    window.jQuery('.selectpicker').selectpicker('refresh');
  }


  Geocode_location(address = '') {
    let THIS = this;
    let add = (address) ? address : this.state.google_address
    Geocode.fromAddress(add).then(
      response => {
        const { lat, lng } = response.results[0].geometry.location;
        THIS.setState({
          latitude: lat,
          longitude: lng
        });
      },
      error => {
        console.error(error);
      }
    );
  }

  customChange = (e, i) => {
    let social_link_data = this.state.social_link_data;
    if (social_link_data.length > 0 && social_link_data[i]) {
      social_link_data[i].link = e.target.value;
    }
    this.setState({ social_link_data });
  };

  handlePaste = (e) => {
    this.Geocode_location();
  };
  handleChange = (e) => {
    const propName = e.target.name;
    this.setState({ [e.target.name]: e.target.value });
  };
  handleSelect = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    this.setState({ [propName]: value });
  };
  escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  shouldRenderSuggestions = (value, reason) => {
    return value.trim().length > 2;
  };
  onSuggestionsFetchRequested = ({ value }) => {
    const val = this.escapeRegexCharacters(value.trim());
    let login_id = this.state.user_data.login_id;
    let fetch = JSON.stringify({
      keyword: val,
      login_id: login_id,
      url: 'getDataByName'
    });
    partnerApi(fetch).then(res => {
      if (res.status == 1) {
        this.setState({
          suggestions: res.result
        });
      }
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  getSuggestionValue = (suggestion) => {
    this.setState({ confirmModal: true });
    let currentData = suggestion;
    currentData.url = 'getDataById';
    let data = JSON.stringify(currentData);
    partnerApi(data).then(res => {
      if (res.status === 1) {
        let data = res.result;
        this.setState({
          registration_no: data.organisation_register_number,
          address: data.address,
          google_address: data.google_address,
          city: data.location,
          state: data.state,
          pincode: data.pin_code,
          contact_number: data.institution_contact_number,
          email: data.institution_email_address,
          social_media: data.social_link,
          social_media_link: data.social_media_link,
          social_link_data: data.social_link_data ? JSON.parse(data.social_link_data) : this.state.social_link_data,
        });
      } else {
        this.setState({
          registration_no: '',
          address: '',
          google_address: '',
          city: '',
          state: '',
          pincode: '',
          contact_number: '',
          email: '',
          social_media: '',
          social_media_link: '',
          social_link_data: this.state.social_link_data,
        });
      }
    });
    return suggestion.name;
  }

  renderSuggestion(suggestion) {
    return (
      <span>{suggestion.name}</span>
    );
  }

  onChange = (event, { newValue, method }) => {
    this.setState({
      org_name: newValue
    });
  };
 
  render() {
 
    this.validator.purgeFields();
    const { user_type, user_data, suggestions, cat_list } = this.state;
    let add_type = user_type == 1 ? ' Of the Institution' : '';
    let type = user_type == 1 ? ' Institution' : '';
    const inputProps = {
      value: this.state.org_name ? this.state.org_name : '',
      onChange: this.onChange,
      name: 'org_name',
      className: 'form-control'
    };

        return (
            <React.Fragment>
                <AdminLayout>
                    
              <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Add a Branch</h4>

                    
                  <form onSubmit={this.submitForm} autoComplete='off' >
            <div class="box-shadow-custom">

              
                <div className='row'>
                  <div class="form-group col-md-4">
                    <label>Name of the Institution <span class="astrick">*</span></label>
                    {/* <input type="text"
                      class="form-control" name="org_name"
                      value={this.state.org_name}
                      onChange={this.handleChange} /> */}
                    <Autosuggest
                      suggestions={suggestions}
                      shouldRenderSuggestions={this.shouldRenderSuggestions}
                      onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                      onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                      getSuggestionValue={this.getSuggestionValue}
                      renderSuggestion={this.renderSuggestion}
                      inputProps={inputProps} />
                    {this.validator.message('Name of the Institution', this.state.org_name, 'required', { className: 'text-danger' })}
                  </div>
                  <div class="form-group col-md-4">
                    <label>Business Registration Number <span class="astrick">*</span></label>
                    <input type="text"
                      class="form-control" name="registration_no"
                      value={this.state.registration_no}
                      onKeyUp={this.autoSave}
                      onChange={this.handleChange} />
                    {this.validator.message('Business Registration Number', this.state.registration_no, 'required|alpha_num', { className: 'text-danger' })}
                  </div>

                  <div class="form-group col-md-4">
                  <label>Category <span class="astrick">*</span></label>
                  <select className="form-control selectpicker"
                        title={"Select Category"}
                        name="selected_cids"
                        multiple
                        onChange={this.handleSelect}>
                        {
                          cat_list.map((item, k) => {
                              return (
                                <option value={item.category_id} >{item.category_name}</option>
                              )
                          })
                        }
                  </select>
                  {this.validator.message('Category', this.state.selected_cids, 'required', { className: 'text-danger' })}
                  </div>    


                </div>
             
              
                <div className='row'>
                  <div class="form-group col-md-4">
                    <label>Name <span class="astrick">*</span></label>
                    <input type="text"
                      class="form-control" name="first_name"
                      value={this.state.first_name}
                      onKeyUp={this.autoSave}
                      onChange={this.handleChange} />
                    {this.validator.message('First Name', this.state.first_name, 'required', { className: 'text-danger' })}
                  </div>
                  {/* <div class="form-group col-md-4">
                    <label>Last Name <span class="astrick">*</span></label>
                    <input type="text"
                      class="form-control" name="last_name"
                      value={this.state.last_name}
                       onKeyUp={this.autoSave}
                      onChange={this.handleChange} />
                    {this.validator.message('Last Name', this.state.last_name, 'required|alpha_num', { className: 'text-danger' })}
                  </div> */}
                </div>
             
              <div className='row'>
                <div class="form-group col-md-6">
                  <label>Address {add_type} <span class="astrick">*</span></label>
                  <input type="text"
                    class="form-control" name="address"
                    value={this.state.address}
                    onKeyUp={this.autoSave}
                    onChange={this.handleChange} />
                  {this.validator.message('Address' + add_type, this.state.address, 'required|not_eq_ho:["'+this.state.temp_org_address+'"]', { className: 'text-danger' })}
                </div>
                <div class="form-group col-md-6">
                  <label>Google Location <i class="fa fa-info-circle info-tool" data-tip data-for="info-goole" aria-hidden="true"></i>
                          <ReactTooltip id="info-goole" place="bottom" effect="solid" className='react_tooltip_backgrnd'>
                              <p>Type and Select From Autopopulated List</p>
                          </ReactTooltip> <span class="astrick">*</span></label>

                  <PlacesAutocomplete
                                value={this.state.google_address}
                                className="form-control"
                                onChange={this.handleplaceChangeIns}
                                onSelect={this.handleplaceSelectIns}
                              >
                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                  <div >
                                    <input
                                      {...getInputProps({
                                        placeholder: 'Search Places ...',
                                        className: 'form-control',
                                        id: 'address_ins'
                                      })}
                                      value={this.state.google_address}
                                    />
                                    <div className="autocomplete-dropdown-container"
                                      style={{ position: "absolute", zIndex: "999" }}>
                                      {loading && <div>Loading...</div>}
                                      {suggestions.map(suggestion => {
                                        const className = suggestion.active
                                          ? 'suggestion-item--active'
                                          : 'suggestion-item';
                                        // inline style for demonstration purpose
                                        const style = suggestion.active
                                          ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                          : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                        return (
                                          <div
                                            {...getSuggestionItemProps(suggestion, {
                                              className,
                                              style,
                                            })}
                                          >
                                            <span>{suggestion.description}</span>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                )}
                              </PlacesAutocomplete>

                
                  {this.validator.message('Google Location', this.state.google_address, 'required', { className: 'text-danger' })}
                </div>
              </div>
              <div className='row'>
                <div class="form-group col-md-4">
                  <label>City <span class="astrick">*</span></label>
                  <select className="form-control selectpicker"
                    title={"Select"}
                    name="city"
                    onChange={this.handleChange}
                    onKeyUp={this.autoSave}
                    value={this.state.city}>
                    {
                      this.state.location_list.map((item, i) => {
                        return (
                          <option key={i + 'L'}>{item.location}</option>
                        )
                      })
                    }
                  </select>
                  {this.validator.message('City', this.state.city, 'required', { className: 'text-danger' })}
                </div>

                <div class="form-group col-md-4">
                  <label>State <span class="astrick">*</span></label>
                  <input type="text"
                    class="form-control" name="state"
                    value={this.state.state}
                    onKeyUp={this.autoSave}
                    onChange={this.handleChange} />
                  {this.validator.message('state', this.state.state, 'required|alpha_num', { className: 'text-danger' })}
                </div>
                <div class="form-group col-md-4">
                  <label>Pincode <span class="astrick">*</span></label>
                  <input type="text"
                    class="form-control" name="pincode"
                    value={this.state.pincode}
                    onKeyUp={this.autoSave}
                    onChange={this.handleChange} />
                  {this.validator.message('pincode', this.state.pincode, 'required|numeric|min:1,num', { className: 'text-danger' })}
                </div>
              </div>
              <div className='row'>
                <div class="form-group col-md-12">
                  <label>{type} Email Address <span class="astrick">*</span></label>
                  <input type="text"
                    class="form-control" name="email"
                    value={this.state.email}
                    onKeyUp={this.autoSave}
                    onChange={this.handleChange} />
                  {this.validator.message(type + 'Email Address', this.state.email, 'required|email', { className: 'text-danger' })}
                </div>
              </div>
              <div className='row'>      
                <div class="form-group col-md-6">
                  <label>{type} Contact Number <span class="astrick">*</span></label>
                 
                  <div className="phone-wrapper-new">
                    
                    <div className='row'>
                      <div class="form-group col-4">
                      <input type="text" name="contact_number_code"
                      placeholder=""
                      onKeyUp={this.autoSave}
                      value="+91"
                      onChange={this.handleChange} className="form-control" disabled/>
                      </div>
                      <div class="form-group col-8">
                    <input type="text" name="contact_number"
                      placeholder=""
                      onKeyUp={this.autoSave}
                      value={this.state.contact_number}
                      onChange={this.handleChange} className="form-control" />
                      </div>
                    </div>

                  </div>
                  {this.validator.message(type + 'Contact Number', this.state.contact_number, 'required|checkMobile|min:10|max:50', { className: 'text-danger' })}
                </div>
                <div class="form-group col-md-6">
                  <label>{type} Landline </label>
                  <input type="text"
                    class="form-control" name="landline"
                    value={this.state.landline}
                    onKeyUp={this.autoSave}
                    onChange={this.handleChange} />
                  {this.validator.message(type + 'Landline', this.state.landline, 'numeric', { className: 'text-danger' })}
                </div>
              </div>
              <div className="row">
                <div class="form-group col-md-12">
                  <label> Social Links <span className="astrick">*</span></label>
                  <table className='table socialtable desktoponly'>
                    <tbody>
                      <tr>
                        <td><b>Media</b></td>
                        {this.state.social_link_data.map((item, i) => {
                          return (
                            <td>{item.name}</td>
                          )
                        })}
                      </tr>
                      <tr>
                        <td><b>Link</b> <i class="fa fa-info-circle info-tool" data-tip data-for="info" aria-hidden="true"></i>
                          <ReactTooltip id="info" place="bottom" effect="solid" className='react_tooltip_backgrnd'>
                            <p>Please start with "https://...."</p>
                          </ReactTooltip>
                        </td>
                        {this.state.social_link_data.map((item, i) => {
                          return (
                            <td>
                              <input type='text' className='form-control' onChange={(e) => this.customChange(e, i)}
                                value={item.link} />
                              {this.validator.message(item.name, item.link, 'url', { className: 'text-danger' })}
                            </td>
                          )
                        })}
                      </tr>
                       
                    </tbody>
                  </table>
                  <table className='table socialtable mobileonly'>
                    <tbody>
                     <tr><th><b>Media</b></th><th><b>Link</b></th></tr>
                     
                        {this.state.social_link_data.map((item, i) => {
                          return (
                            <tr>
                              <td>{item.name}</td>
                              <td>
                              <input type='text' className='form-control' onChange={(e) => this.customChange(e, i)}
                                value={item.link} />
                              {this.validator.message(item.name, item.link, 'url', { className: 'text-danger' })}
                            </td>
                            </tr>
                          )
                        })}
                     
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
            <div className='box-shadow-custom'>
            <h5 className='astrick'><b>Notes</b></h5>
            <ul>
              <li>Please suffix location to the name of the institution when you add a branch or category</li>
              <li>If you need help - please write to us at contact@bewise.in</li>
            </ul>
          </div>
          
            <div class="col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm">
              <a href="/partner/profile" alt="back" class="btn btn-primary btn-sm">Back</a>&nbsp;
              <button type='submit' id="btnSubmit"
                className="btn btn-primary btn-sm" disabled={this.state.btnDisabled}>
                {this.state.button}
              </button>
            </div>
          </form>  

                </div>
              </div>

              
            </div>  
            <NotificationContainer/>

                </AdminLayout>
            </React.Fragment>
        )
    }

    submitForm = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {

         
          const { user_type, login_id } = this.state.user_data;
          let request = JSON.stringify({
            vendor_id:this.state.vendor_id,
            user_type: user_type,
            master_data: this.state.master_data,
            uids: this.state.uids,
            cids: this.state.cids,
            selected_cids:this.state.selected_cids, 
            login_id: login_id,
            is_completd: this.state.is_completd,
            registration_no: this.state.registration_no,
            org_name: this.state.org_name,
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            address: this.state.address,
            google_address: this.state.google_address,
            latitude: this.state.latitude,
            longitude: this.state.longitude,
            city: this.state.city,
            state: this.state.state,
            pincode: this.state.pincode,
            email: this.state.email,
            contact_number: this.state.contact_number,
            landline: this.state.landline,
            social_media: this.state.social_media,
            social_media_link: this.state.social_media_link,
            social_link_data: JSON.stringify(this.state.social_link_data),
            access: this.state.access,
            sub_category: this.state.sub_category,
            main_access: this.state.main_access,
            type_one: this.state.type_one,
            type_two: this.state.type_two
          });

          //console.log(request);
          
          partnerAddBranch(request).then(res => {
            if (res.status === 1) {
                NotificationManager.success(res.message);
                this.setState({btnDisabled:true});
                setTimeout(function () {
                  '/partner/profile'
                }, 1000);

            } else {
                NotificationManager.error(res.message);
                this.setState({btnDisabled:false});
            }
          });
          

        } else {
          this.validator.showMessages();
          this.forceUpdate();
        }
    }

}

export default partnerBranchAdd;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/branchadd.jsx